import React, { useState, useEffect } from 'react';
import { getMeta } from '~target';
import { getDeal, dealsEnabled } from '~modules/deals';

import Screen from '~co/screen/basic';
import Header from './header';
import Content from './content';

//faster load of current tab
var _cached = null,
  _deal = null;
const currentTab = getMeta()
  .then((val) => (_cached = val))
  .catch(() => {});
const currentDeal = dealsEnabled()
  .then((on) => (on ? getDeal() : null))
  .then((val) => (_deal = val))
  .catch(() => {});
//-----

export default function Clipper(props) {
  const [item, setItem] = useState(_cached);
  const [deal, setDeal] = useState(_deal);
  //an async useEffect returns a Promise, which React stores as the effect
  //destroy fn — unmounting then calls Promise() and crashes the whole tree
  //(blank page when navigating clipper → settings inside the popup)
  useEffect(() => {
    (async () => {
      if (!item) setItem(await currentTab);
      if (!deal) setDeal(await currentDeal);
    })();
  }, []);

  return (
    <Screen>
      {item ? (
        <>
          <Header {...props} item={item} deal={deal} />
          <Content {...props} item={item} deal={deal} />
        </>
      ) : null}
    </Screen>
  );
}
